import useMessageList from "./hooks/useMessageList";
import MessageCard from "./MessageCard";
import Loader from "../../components/Loader";
import styles from "./messageList.module.css";

const MessageList = ({ messages, waiting }) => {
  const { messageEndRef } = useMessageList({ messages, waiting });
  return (
    <div className={styles.messageList}>
      {Array.isArray(messages)
        ? messages.map((message) => (
            <MessageCard key={JSON.stringify(message?.id)} {...message} />
          ))
        : null}
      {waiting && (
        <div>
          <Loader small />
        </div>
      )}
      <div ref={messageEndRef} />
    </div>
  );
};

export default MessageList;
